module.exports = __webpack_public_path__ + "img/alkalmazasok_dll.a5d75388.png";